define([
    './JsonRPCService',
    './DefaultErrorHandlerService',

    // start l10n
    'l10nModule',
    // end l10n

    'angular-animate',
    'bower_components/angular-aria/angular-aria',
    'portalConfig',
    'edge/platform/util/module',
    'edge/platform/widgets/loading/module',
    'edge/platform/widgets/modal/module',
    'edge/platform/transport/module',
    'edge/platform/decorator/module',
    'edge/platform/atomic_design/module',
    'edge/platform/widgets/dropdown/module',
    'edge/platform/widgets/pagestructure/module',
    'edge/platform/widgets/tabs/module',
    'edge/platform/branding/module'
], (JsonRPCService, DefaultErrorHandlerService)=> {
    return angular.module('edge.platform.base', [
            'ngAnimate',
            'ngAria',
            'portal.config',
            'edge.platform.util',
            'edge.platform.transport',
            'edge.platform.widgets.loadingMsg',
            'edge.platform.widgets.modal',
            'edge.platform.decorator',
            // start l10n
            'edge.platform.l10n',
            // end l10n
            'edge.platform.atomic_design',
            'edge.platform.widgets.dropdown',
            'edge.platform.widgets.pagestructure',
            'edge.platform.widgets.tabs',
            'edge.platform.branding'
        ]) // -32768 to -32000 are reserved for pre-defined errors, The remainder of the space is available for application defined errors.
        .constant('ERROR_CODES', {
            PARSE_ERROR: -32700,
            INVALID_REQUEST: -32600,
            METHOD_NOT_FOUND: -32601,
            INVALID_PARAMS: -32602,
            INTERNAL_ERROR: -32603,
            GW_MNP_SECURITY_ERROR: -33000,
            GW_MNP_VALIDATION_ERROR: -33001,
            GW_MNP_QUOTE_SESSION_TIMEOUT: -33004

        })
        .constant('uiConstants', {
            SUBMITTED: 'submitted'
        })

        .factory('JsonRPCService', JsonRPCService)
        .provider('DefaultErrorHandlerService', DefaultErrorHandlerService);
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/base/module.js
 **/